module.exports = __webpack_public_path__ + "img/nurse.8528dc11.png";